import TextField from './fields/TextField';
import I18nTextField from './fields/I18nTextField';
import ColorField from './fields/ColorField';
import NumberField from './fields/NumberField';
import SelectField from './fields/SelectField';
import ToggleField from './fields/ToggleField';
import ImageField from './fields/ImageField';
import IconPickerField from './fields/IconPickerField';
import CollectionField from './fields/CollectionField';
import TagsField from './fields/TagsField';

function FieldRenderer({ fieldDef, value, onDirectChange, blockPath, dispatch, config, editMode }) {
  const handleChange = (newValue) => {
    if (onDirectChange) {
      onDirectChange(newValue);
    }
  };

  switch (fieldDef.type) {
    case 'i18nText':
      return (
        <I18nTextField
          label={fieldDef.label}
          translationKey={value}
          multiline={fieldDef.multiline}
          onKeyChange={(newKey) => {
            if (onDirectChange) {
              onDirectChange(newKey);
            }
          }}
        />
      );

    case 'text':
    case 'url':
      return (
        <TextField
          label={fieldDef.label}
          value={value}
          onChange={handleChange}
          multiline={fieldDef.multiline}
        />
      );

    case 'color':
      return (
        <ColorField
          label={fieldDef.label}
          value={value}
          onChange={handleChange}
        />
      );

    case 'number':
      return (
        <NumberField
          label={fieldDef.label}
          value={value}
          onChange={handleChange}
          unit={fieldDef.unit || 'px'}
          min={fieldDef.min}
          max={fieldDef.max}
        />
      );

    case 'select':
      return (
        <SelectField
          label={fieldDef.label}
          value={value}
          onChange={handleChange}
          options={fieldDef.options}
        />
      );

    case 'toggle':
      return (
        <ToggleField
          label={fieldDef.label}
          value={value}
          onChange={handleChange}
        />
      );

    case 'image':
      return (
        <ImageField
          label={fieldDef.label}
          value={value}
          onChange={handleChange}
          editMode={editMode}
        />
      );

    case 'icon':
      return (
        <IconPickerField
          label={fieldDef.label}
          value={value}
          onChange={handleChange}
        />
      );

    case 'collection':
      return (
        <CollectionField
          label={fieldDef.label}
          items={value || []}
          onChange={handleChange}
          fieldDef={fieldDef}
          blockPath={blockPath}
          dispatch={dispatch}
          config={config}
          editMode={editMode}
        />
      );

    case 'tags':
      return (
        <TagsField
          label={fieldDef.label}
          value={value}
          onChange={handleChange}
        />
      );

    default:
      return (
        <TextField
          label={fieldDef.label}
          value={typeof value === 'string' ? value : JSON.stringify(value)}
          onChange={handleChange}
        />
      );
  }
}

export default FieldRenderer;
